import React, { useState, useEffect } from "react"
import ProgressBar from "../Components/ProgressBar"
import firebase from "../firebase"

const Services = () => {
  const [skills, setSkills] = useState([])
  const [viewMore, setviewMore] = useState(5)

  const colors = ["bg-success", "bg-info", "bg-danger"]

  useEffect(() => {
    const skillRef = firebase.database().ref("Skills")
    skillRef.on("value", (snapshot) => {
      const skillsList = []
      const skills = snapshot.val()
      for (let id in skills) {
        skillsList.push(skills[id])
      }
      setSkills(skillsList)
    })
  }, [])

  return (
    <section id="services">
      <div className="container">
        <div className="row">
          <div className="col-12 mb-4">
            <h1 className="sectionname text-center">Services</h1>
            <hr className="mx-auto" />
          </div>
          <div className="col-lg-6 my-lg-5 mb-3 pt-3 pr-5" data-aos="fade-up">
            {skills.slice(0, viewMore).map((skill, index) => {
              return (
                <ProgressBar
                  key={index}
                  skillName={skill.skillName}
                  percentage={skill.percentage}
                  bgColor={colors[index % 3]}
                />
              )
            })}
            {viewMore < skills.length && (
              <div className="text-center mt-3">
                <button
                  className="btn btn-outline-primary more"
                  onClick={() => {
                    setviewMore((prev) => {
                      return prev + 1
                    })
                  }}>
                  View More
                </button>
              </div>
            )}
            {viewMore >= skills.length && (
              <div className="text-center mt-3">
                <button
                  className="btn btn-outline-primary more"
                  onClick={() => setviewMore(5)}>
                  Show Less
                </button>
              </div>
            )}
          </div>
          <div className="col-lg-6 my-5 p-4" data-aos="fade-up">
            <div className="row">
              <div className="col-2 mb-5 Services__icon">
                <i className="fa fa-desktop fa-3x" aria-hidden="true"></i>
              </div>
              <div className="col-10">
                <h2>Website Devlopment</h2>
                <p>
                  I'm available for freelancing.i have great experience in
                  web-devlopment.
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-2 mb-5 pl-4 Services__icon">
                <i className="fa fa-mobile fa-3x" aria-hidden="true"></i>
              </div>
              <div className="col-10">
                <h2>Mobile Devlopment</h2>
                <p>
                  I have also great experience in mobile devlopment(React
                  Native).
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-2 mb-5 pl-4 Services__icon">
                <i className="fa fa-phone-alt fa-3x" aria-hidden="true"></i>
              </div>
              <div className="col-10">
                <h2>Support 24/7</h2>
                <p>You can contact me for your query any time.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Services
